import { Pipe, PipeTransform } from '@angular/core';
import { Utility } from 'src/app/core/common';

@Pipe({
  name: 'filter',
  pure: true
})
export class FilterPipe implements PipeTransform {

  transform(array: any[], filters: any, search?: string, page?: any, not?: boolean) {
    if (!array) return array;
    search = search?.toLowerCase();
    var props = filters ? Object.getOwnPropertyNames(Utility.removeUndefined(filters)) : null;
    var result = array
      .filter(v => props?.every(p => filters[p] instanceof Array ? filters[p].some((x: any) => v[p] === x) : filters[p] === v[p]) != false)
      // .filter(v => !search || Object.keys(v).some(k => v[k] && v[k].toString().toLowerCase().includes(search)));
      .filter(v => !search || JSON.stringify(v).toLowerCase().includes(search));
    if (not)
      result = array.filter(v => !result.includes(v));

    if (!page) return result;
    page.total = result.length;
    return result.slice(page.from || 0, page.limit ? page.from + page.limit : null);
  }

}
